import {Controller} from '@hotwired/stimulus';

export default class HelloController extends Controller<HTMLFormElement> {
  connect() {
    this.element.textContent = 'Hello World!';
  }
}
